export default function setFormSelect() {

  /* Elements */
  const formElm = document.querySelector('form');
  const selectElm = formElm.querySelectorAll('select');
  const optionElm = formElm.querySelectorAll('select option');

  // selectElm.forEach(sel => {
  //   sel.options[0].setAttribute('hidden',true);
  //   console.log('ss')
  // });

  // フォーム入力値の変更を検知
  formElm.addEventListener('change', (e) => {

    let selectAry = [];

    // 選択値を取得
    selectElm.forEach(sel => {
      let num = sel.selectedIndex;
      let str = sel.options[num].value;
      selectAry.push(str);
    });

    optionElm.forEach(opt => {
      opt.removeAttribute('hidden','hidden'); // 一度全て解除
      // opt.disabled = false; // 一度全て解除

      let _val = opt.value;
      selectAry.forEach(sel => {
        if (_val === sel) {
          opt.setAttribute('hidden','hidden');
        }
      });
    });

  });

}